/**
 * Constants for duplicated string literals
 */
export const SELECTORS = {
  DATA_SECTION: 'data-section',
  PRODUCT_TOUR: '.product-tour',
};

/**
 * View type constants
 */
export const VIEW_TYPES = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

/**
 * Image dimensions constants to avoid magic numbers
 */
export const IMAGE_DIMENSIONS = {
  DESKTOP_WIDTH: 2000,
  MOBILE_WIDTH: 750,
};

export const PLACEHOLDER_IMAGE_PATH = '/edge/icons/error_alert.svg';

export const HANDRAISER_BUTTON_TYPES = {
  DEMO: 'Demo',
  QUOTE: 'Quote',
  MEETING: 'Meeting',
  CALL: 'Call',
  CONTACT: 'Contact',
};

export const BUTTON_TYPES = {
  ...HANDRAISER_BUTTON_TYPES,
  TRIAL: 'Trial',
};

export const BUTTONS_ATTRIBUTES_MAP = {
  [BUTTON_TYPES.DEMO]: { id: 'requestDemo' },
  [BUTTON_TYPES.CONTACT]: { id: 'contactUs' },
  [BUTTON_TYPES.CALL]: { id: 'requestCall' },
  [BUTTON_TYPES.QUOTE]: { id: 'requestDemo' },
  [BUTTON_TYPES.MEETING]: { id: 'requestMeeting' },
};

export const HANDRAISER_BUTTON_PATHS = {
  [HANDRAISER_BUTTON_TYPES.DEMO]: '/registration/request-demo.html',
  [HANDRAISER_BUTTON_TYPES.CONTACT]: '/registration/contact.html',
  [HANDRAISER_BUTTON_TYPES.CALL]: '/registration/request-call.html',
  [HANDRAISER_BUTTON_TYPES.QUOTE]: '/registration/request-quote.html',
  [HANDRAISER_BUTTON_TYPES.MEETING]: '/registration/request-meeting.html',
};
